export const benefitsList = [
  {
    title: "benefits.vms.title",
    description: "benefits.vms.description",
    iconUrl: "vms",
  },
  {
    title: "benefits.gpu.title",
    description: "benefits.gpu.description",
    iconUrl: "gpu",
  },
];

export const keyCapabilitiesList = [
  {
    title: "keyCapabilities.memoryEncription.title",
    description: "keyCapabilities.memoryEncription.description",
  },
  {
    title: "keyCapabilities.isolation.title",
    description: "keyCapabilities.isolation.description",
  },
  {
    title: "keyCapabilities.secureBoot.title",
    description: "keyCapabilities.secureBoot.description",
  },
  {
    title: "keyCapabilities.remoteAttestation.title",
    description: "keyCapabilities.remoteAttestation.description",
  }
];

export const confidentialReasonsList = [
  {
    title: "confidentialReasons.noCode.title",
    description: "confidentialReasons.noCode.description",
  },
  {
    title: "confidentialReasons.verification.title",
    description: "confidentialReasons.verification.description",
  },
  {
    title: "confidentialReasons.performance.title",
    description: "confidentialReasons.performance.description",
  },
  {
    title: "confidentialReasons.support.title",
    description: "confidentialReasons.support.description",
  }
]
